module.exports = __webpack_public_path__ + "static/media/glider2.8062bec1.svg";